<template>
  <div>
    <!-- table 暂未翻译 -->
    <el-dialog :title="$i18.language('小易AI在线支付')" :visible.sync="dialogVisible" width="504px" :before-close="handleClose">
      <div class="chat-title">{{ $i18.language('请选择开通在线服务')}} {{$i18.language('(开通服务后公司所属账户都将获得 Pro 权益)')}}</div>
      <table class="table-style">
        <tr>
          <th>-</th>
          <th>{{ $i18.language('小易AIPro提问包') }}</th>
          <th>{{ $i18.language('普通体验版') }}</th>
        </tr>
        <tr>
          <td>{{ $i18.language('对话次数') }}</td>
          <td class="font-color">{{ tableData.Conversations }}</td>
          <td>{{ $i18.language('10次/天') }}</td>
        </tr>
        <tr>
          <td>{{ $i18.language('历史对话') }}</td>
          <td  class="font-color">{{ tableData.Dialog }}</td>
          <td>{{ $i18.language('保留7天') }}</td>
        </tr>
        <tr>
          <td>{{ $i18.language('上下文能力') }}</td>
          <td class="font-color">{{ tableData.Context }}</td>
          <td>-</td>
        </tr>
        <tr>
          <td>{{ $i18.language('价格') }}</td>
          <td class="font-color">{{ tableData.Price }}</td>
          <td>-</td>
        </tr>
      </table>
      <div class="pay">
        <el-button type="primary" class="confirm-btn" @click="payNow">{{ $i18.language('立即支付') }}</el-button>
      </div>
      <div class="agreement">
        <el-checkbox class="xy-check" v-model="policyChecked" size="mini">
          <span style="color: #999999">{{ $i18.language('我已阅读并同意') }}</span
          ><a :href="enlangs ? `${ePlatformUrl}policyEn.html` : `${ePlatformUrl}policy.html`" target="_blank">{{ $i18.language('《用户隐私政策》') }}</a
          ><span>{{ $i18.language('和') }}</span>
          <a :href="enlangs ? `${ePlatformUrl}e_policyEn.html` : `${ePlatformUrl}e_policy.html`" target="_blank">{{ $i18.language('《服务条款》') }}</a>
        </el-checkbox>
      </div>
    </el-dialog>
    <chat-pay ref="chatPay" :price="tableData.DiscountPrice" @chatTable='chatTable'></chat-pay>
  </div>
</template>

<script>
import chatPay from '@/components/chatView/chatPay'
export default {
  name: 'chatTable',
  components: {
    chatPay,
  },
  computed: {
    enlangs() {
      return localStorage.getItem('language') == 'en'
    },
  },
  data() {
    return {
      dialogVisible: false,
      policyChecked: true,
      ePlatformUrl: '',
      tableData: {},
    }
  },

  mounted() {
    this.ePlatformUrl = 'https://et.topease.net/'
  },
  methods: {
    chatTable(){
      this.$emit('chatTableF')
    },
    rechargeProducts() {
      this.$api.public.rechargeProducts({ status: 19 }).then((res) => {
        if (res && res.code == 200) {
          this.tableData = res.data[0]
        }
      })
    },
    handleClose() {
      this.$emit('closeF')
    },
    payNow() {
      if (this.policyChecked) {
        this.dialogVisible = false
        this.$refs.chatPay.dialogVisible = true
        this.$refs.chatPay.getPayCode()
      } else {
        this.$message.warning(this.$i18.language('请阅读并勾选《用户隐私政策》以及《服务条款》'))
      }
    },
  },
}
</script>

<style lang="scss" scoped>
/deep/.el-dialog__wrapper {
  z-index: 999999 !important;
}
.agreement {
  width: 100%;
  font-size: 14px;
  text-align: center;
  margin-top: 20px;
}
/deep/.xy-check {
  a {
    color: $--color-primary-6;
    text-decoration: underline;
  }
  &.is-checked {
    .el-checkbox__input {
      .el-checkbox__inner {
        background-color: $--color-primary-6;
        border-color: $--color-primary-6;
      }
    }
  }
  .el-checkbox__input {
    .el-checkbox__inner {
      width: 12px;
      height: 12px;
      &::after {
        left: 3px;
        top: 0;
      }
      &:hover {
        border-color: $--color-primary-6;
      }
    }
  }
  .el-checkbox__label {
    font-size: 12px;
    color: #898d90;
  }
}
/deep/.el-dialog__footer {
  text-align: center;
}
.chat-title {
  font-size: 12px;
  color: #1a173b;
  margin-bottom: 29px;
}
.table-style {
  width: 374px;
  text-align: center;
  margin: 0 auto;
  //   border: 1px solid #d8dee6
  border-collapse: collapse;
  border-radius: 4px;
}
.table-style td,
th {
  height: 40px;
  line-height: 17px;
  border: 1px solid #d8dee6;
}
.table-style > tr:nth-child(1) > th {
  background: #f8f8f8;
}
.table-style > tr:nth-child(1) > th:nth-child(2) {
  background: rgba(234, 85, 25, 0.1);
  color: #ea5519;
}
.table-style > tr:nth-child(1) > th:nth-child(2) {
  background: rgba(234, 85, 25, 0.1);
  color: #ea5519;
}
.table-style > tr > th:nth-child(3),
.table-style > tr > td:nth-child(3) {
  color: #999999;
}
.table-style > tr > th:nth-child(1),
.table-style > tr > td:nth-child(1) {
  border-right: 1px solid #ea5519;
}
.table-style > tr > th:nth-child(2),
.table-style > tr > td:nth-child(2) {
  border-right: 1px solid #ea5519;
}
.table-style > tr:first-child > th:nth-child(2) {
  border-top: 1px solid #ea5519;
}
.table-style > tr:last-child > td:nth-child(2) {
  border-bottom: 1px solid #ea5519;
}
// .table-style > tr > td:nth-child(2) {
//   transform:scale(2)
// }
.pay {
  margin-top: 30px;
  text-align: center;
}
.font-color{
  color:#ea5519
}
</style>
